import { GoHome } from "react-icons/go";
import { LuChartBar } from "react-icons/lu";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { IoMdCodeWorking } from "react-icons/io";
import { IoCodeSlashOutline } from "react-icons/io5";
import { BiBriefcase } from "react-icons/bi";
import { LuUser } from "react-icons/lu";
import { LiaUserLockSolid } from "react-icons/lia";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { GrCurrency } from "react-icons/gr";
import { IoSettingsOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import { createContext, useContext } from "react";

import APICaller from "../../utils/APICaller";
import { FaRegCalendarAlt } from "react-icons/fa";
import { message } from "antd";

export const downloadMonthWiseExpenseRequestReport = async (
  storeRole,
  storeToken,
  storeLIUId,
  storeAccessTokenExpiresOn,
  currentPath,
  status,
  hasSearchValue,
  setShowLoader,
) => {
  try {
    const exportColumns = [
      { key: "empName", path: "empName" },
      { key: "empID", path: "empID" },
      { key: "natureOfExpense", path: "natureOfExpense" },
      { key: "vendorName", path: "businessPurpose" },
      { key: "projectCodeID", path: "projectCodeID" },
      { key: "companyName", path: "" },
      { key: "expensePeriod", path: "" },
      { key: "month", path: "expensePeriodFromDate" },
      { key: "departmentID", path: "departmentID" },
      { key: "expenseCodeID", path: "" },
      { key: "currencyID", path: "" },
      { key: "cost", path: "" },
      { key: "totalReimbursement", path: "totalReimbursement" },
      { key: "approvers", path: "" },
      { key: "adminApprover", path: "" },
      { key: "status", path: "status" },
      { key: "paymentPaidOn", path: "paymentPaidOn" },
      { key: "modeOfPayment", path: "modeOfPayment" },
    ];
    // Select the input element using the date-range attribute
    let startRange = "";
    let endRange = "";
    const startMonthInput = document.querySelector('input[date-range="start"]');

    if (startMonthInput.value) {
      // Get the value of the input
      startRange = `${new Date(startMonthInput.value).getFullYear()}-${String(
        new Date(startMonthInput.value).getMonth() + 1,
      ).padStart(2, "0")}`;
    }

    // Select the input element using the date-range attribute
    const endMonthInput = document.querySelector('input[date-range="end"]');

    if (endMonthInput.value) {
      // Get the value of the input
      endRange = `${new Date(endMonthInput.value).getFullYear()}-${String(
        new Date(endMonthInput.value).getMonth() + 1,
      ).padStart(2, "0")}`;
    }

    const endpoint = "/downloadAll";
    const method = "POST";
    const payload = {
      role: storeRole,
      month: startRange && endRange ? { startRange, endRange } : "",
      exportOf: "expenseRequest",
      exportColumns: exportColumns,
      status,
      lIUId: storeLIUId,
      searchKeyword: hasSearchValue || "",
    };

    const response = await APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn,
      "blob",
    );

    //Check if the response data is a Blob
    if (response instanceof Blob) {
      // Create a Blob from the response
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${currentPath}.xlsx`;

      // Append to the DOM
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Revoke the Blob URL after the download
      window.URL.revokeObjectURL(link.href);

      // Clean up
      document.body.removeChild(link);

      message.success("Download done successfully");
      setShowLoader(false);
    } else {
      console.error("Expected a Blob, but got:", response);
      setShowLoader(false);
    }
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const flattenDataForExcel = (data) => {
  // Define the exact column order
  const columnOrder = [
    "empName",
    "empID",
    "natureOfExpense",
    "businessPurpose",
    "projectCodeID",
    "companyName",
    "expensePeriod",
    "month",
    "departmentID",
    "expenseCodeID",
    "currencyID",
    "cost",
    "totalReimbursement",
    "approvers",
    "adminApprover",
    "status",
    "paymentPaidOn",
    "modeOfPayment",
  ];
  const result = [];
  data.forEach((item) => {
    const { key, id, children, ...filteredData } = item;

    // Reorder columns for the parent
    // Reorder parent row according to columnOrder
    const reorderedParent = columnOrder.reduce((acc, key) => {
      acc[key] = filteredData[key] || "-"; // Use empty string if the field is missing
      return acc;
    }, {});

    // Add the parent row with all values
    result.push(reorderedParent);

    // Add children rows with only relevant columns
    if (children) {
      children.forEach((child) => {
        const reorderedChild = columnOrder.reduce((acc, key) => {
          acc[key] = child[key] || ""; // Ensure child fields follow the same order
          return acc;
        }, {});
        result.push(reorderedChild);
      });
    }
  });
  return result;
};

export const sortData = (data) => {
  return data.sort((a, b) => {
    if (a.label < b.label) {
      return -1; // a comes before b
    }
    if (a.label > b.label) {
      return 1; // a comes after b
    }
    return 0; // a and b are equal
  });
};
export const paginationOptions = (storeTotalCount) => {
  if (typeof storeTotalCount !== "number" || storeTotalCount <= 0) {
    // Fallback to default pagination options if storeTotalCount is invalid
    return ["10", "20", "50", "100"];
  }
  return storeTotalCount > 100
    ? ["10", "20", "50", "100"] //, `${storeTotalCount}`
    : storeTotalCount < 10
      ? [`${storeTotalCount}`, "10", "20", "50", "100"]
      : (() => {
          const baseOptions = ["10", "20", "50", "100"];
          if (!baseOptions.includes(`${storeTotalCount}`)) {
            baseOptions.push(`${storeTotalCount}`);
          }
          return baseOptions.sort((a, b) => Number(a) - Number(b));
        })();
};
export const sideMenu = {
  SUPERADMIN: [
    { "/dashboard": { name: "Dashboard", icon: <GoHome /> } },
    { "/list-of-expense": { name: "List of Expense", icon: <LuChartBar /> } },
    {
      "/pending-requests": {
        name: "Pending Requests",
        icon: <VscGitPullRequestGoToChanges />,
        showCount: "yes",
      },
    },
    { "/project-code": { name: "Project Code", icon: <IoMdCodeWorking /> } },
    { "/expense-code": { name: "Expense Code", icon: <IoCodeSlashOutline /> } },
    {
      "/departments": {
        name: "Departments",
        icon: <HiOutlineBuildingOffice2 />,
      },
    },
    {
      "/currency": {
        name: "Currency",
        icon: <GrCurrency />,
      },
    },
    { "/roles": { name: "Roles", icon: <BiBriefcase /> } },
    { "/permissions": { name: "Permissions", icon: <LiaUserLockSolid /> } },
    { "/users": { name: "Users", icon: <LuUser /> } },
    {
      "/pending-user-configuration": {
        name: "Pending User Configuration",
        icon: <LuUser />,
      },
    },
    {
      "/notifications": {
        name: "Notifications",
        icon: <MdOutlineNotificationsActive />,
      },
    },
    { "/settings": { name: "Settings", icon: <IoSettingsOutline /> } },
    {
      "/expense-calendar-control": {
        name: "Expense Calendar Control",
        icon: <FaRegCalendarAlt />,
      },
    },
  ],
  ADMIN: [
    { "/dashboard": { name: "Dashboard", icon: <GoHome /> } },
    { "/list-of-expense": { name: "List of Expense", icon: <LuChartBar /> } },
    {
      "/pending-requests": {
        name: "Pending Requests",
        icon: <VscGitPullRequestGoToChanges />,
        showCount: "yes",
      },
    },
    { "/project-code": { name: "Project Code", icon: <IoMdCodeWorking /> } },
    { "/expense-code": { name: "Expense Code", icon: <IoCodeSlashOutline /> } },
    {
      "/departments": {
        name: "Departments",
        icon: <HiOutlineBuildingOffice2 />,
      },
    },
    {
      "/currency": {
        name: "Currency",
        icon: <GrCurrency />,
      },
    },
    {
      "/notifications": {
        name: "Notifications",
        icon: <MdOutlineNotificationsActive />,
      },
    },
    {
      "/expense-calendar-control": {
        name: "Expense Calendar Control",
        icon: <FaRegCalendarAlt />,
      },
    },
    {
      "/pending-user-configuration": {
        name: "Pending User Configuration",
        icon: <LuUser />,
      },
    },
  ],
  APPROVER: [
    { "/dashboard": { name: "Dashboard", icon: <GoHome /> } },
    { "/list-of-expense": { name: "List of Expense", icon: <LuChartBar /> } },
    {
      "/pending-requests": {
        name: "Pending Requests",
        icon: <VscGitPullRequestGoToChanges />,
        showCount: "yes",
      },
    },
    { "/project-code": { name: "Project Code", icon: <IoMdCodeWorking /> } },
    {
      "/notifications": {
        name: "Notifications",
        icon: <MdOutlineNotificationsActive />,
      },
    },
  ],
  EMPLOYEE: [
    { "/dashboard": { name: "Dashboard", icon: <GoHome /> } },
    { "/list-of-expense": { name: "List of Expense", icon: <LuChartBar /> } },
    { "/project-code": { name: "Project Code", icon: <IoMdCodeWorking /> } },
    {
      "/notifications": {
        name: "Notifications",
        icon: <MdOutlineNotificationsActive />,
      },
    },
  ],
};

/*Custom hook to call currentPath*/
export default function useCurrentPath() {
  const location = useLocation();
  return location.pathname.replace("/", "");
}

// Define a secret key for encryption/decryption
const SECRET_KEY = "@ex#mgtSys"; // Make sure to use a strong key

export const encryptData = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const encryptCryptoData = async (data) => {
  try {
    const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY;

    if (!SECRET_KEY) {
      throw new Error("SECRET_KEY missing");
    }

    const enc = new TextEncoder();

    const key = await window.crypto.subtle.importKey(
      "raw",
      enc.encode(SECRET_KEY),
      "AES-GCM",
      false,
      ["encrypt"],
    );

    const iv = window.crypto.getRandomValues(new Uint8Array(12));

    const cipher = await window.crypto.subtle.encrypt(
      {
        name: "AES-GCM",
        iv,
      },
      key,
      enc.encode(JSON.stringify(data)),
    );

    return {
      iv: Array.from(iv),
      data: btoa(String.fromCharCode(...new Uint8Array(cipher))),
    };
  } catch (error) {
    console.error("encryptCryptoData error:", error);
    return null;
  }
};

export const deriveKey = (password, salt) => {
  return CryptoJS.PBKDF2(password, salt, {
    keySize: 256 / 32,
    iterations: 65536,
  });
};

export const decrypt = (encryptedData, encryptionKey) => {
  try {
    // Decode the base64 encrypted data into a byte array
    const combined = CryptoJS.enc.Base64.parse(encryptedData);

    // Extract salt (first 16 bytes)
    const salt = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4));

    // Extract IV (next 16 bytes)
    const iv = CryptoJS.lib.WordArray.create(combined.words.slice(4, 8));

    // The remaining part is the encrypted content
    const encrypted = CryptoJS.lib.WordArray.create(combined.words.slice(8));

    // Derive the secret key using PBKDF2 with the provided salt
    const secretKey = deriveKey(encryptionKey, salt);

    // Decrypt the data using AES with the derived key and IV
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encrypted },
      secretKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7, // Ensure proper padding
      },
    );

    // Return the decrypted data as a UTF-8 string
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    // Check if decryption is successful
    if (!decryptedText) {
      throw new Error("Decrypted data is empty or invalid UTF-8.");
    }

    return decryptedText;
  } catch (error) {
    console.error("Decryption error:", error.message);
    return null;
  }
};
